const MobileMenuIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.5 11.175H11.7375C11.2875 11.175 10.875 11.55 10.875 12.0375C10.875 12.4875 11.25 12.9 11.7375 12.9H22.5C22.95 12.9 23.3625 12.525 23.3625 12.0375C23.3625 11.55 22.95 11.175 22.5 11.175Z" fill="#111928"/>
    <path d="M22.5002 17.55H1.5002C1.0502 17.55 0.637695 17.925 0.637695 18.4125C0.637695 18.9 1.0127 19.275 1.5002 19.275H22.5002C22.9502 19.275 23.3627 18.9 23.3627 18.4125C23.3627 17.925 22.9502 17.55 22.5002 17.55Z" fill="#111928"/>
    <path d="M1.5002 6.4501H22.5002C22.9502 6.4501 23.3627 6.0751 23.3627 5.5876C23.3627 5.1001 22.9877 4.7251 22.5002 4.7251H1.5002C1.0502 4.7251 0.637695 5.1001 0.637695 5.5876C0.637695 6.0751 1.0502 6.4501 1.5002 6.4501Z" fill="#111928"/>
    </svg>
  );
};

export default MobileMenuIcon;
